// src/pages/admin/ProduccionHome.jsx
import React from "react";
import { Link } from "react-router-dom";
import AdminHeader from "../../components/AdminHeader";
import AdminPageHeader from "../../components/admin/AdminPageHeader";

export default function ProduccionHome() {
  return (
    <>
      <AdminHeader />

      <main
        style={{
          maxWidth: 1000,
          margin: "2rem auto",
          padding: "0 16px",   // 🔥 CLAVE MOBILE
          boxSizing: "border-box",
          fontFamily: "Questrial, sans-serif",
        }}
      >

        {/* 🔥 NUEVO HEADER INTERNO */}
        <AdminPageHeader
          title="Producción"
          subtitle="Oficina de creación de activos."
          backTo="/admin"
        />

        {/* KPI strip (placeholder V1) */}
        <section
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
            gap: 10,
            marginBottom: 14,
          }}
        >
          {[
            { label: "Activos", value: "-", hint: "Contenido creado en Producción" },
            { label: "Borradores", value: "-", hint: "Contenido en desarrollo" },
            { label: "Publicados", value: "-", hint: "Disponible para miembros" },
          ].map((k) => (
            <div
              key={k.label}
              style={{
                border: "1px solid #e6ebf1",
                borderRadius: 12,
                padding: "14px",
                background: "#fff",
                boxShadow: "0 10px 30px rgba(0,0,0,.05)",
              }}
            >
              <div style={{ fontSize: 12, color: "rgba(44,59,81,.6)", fontWeight: 800 }}>
                {k.label}
              </div>
              <div style={{ fontSize: 22, fontWeight: 900, color: "#0a2230", marginTop: 6 }}>
                {k.value}
              </div>
              <div style={{ marginTop: 2, fontSize: "0.85rem", color: "#6b7a88" }}>
                {k.hint}
              </div>
            </div>
          ))}
        </section>

        {/* Grid de áreas */}
        <section
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 12,
          }}
        >

          <Link to="/admin/systems" style={cardStyle}>
            <Card title="Sistemas" desc="Crear y organizar sistemas de formación." />
          </Link>

          <Link to="/admin/produccion/editorial" style={cardStyle}>
            <Card title="Editorial" desc="Artículos, manifiestos y contenido abierto." />
          </Link>

          <Link to="/admin/tools" style={cardStyle}>
            <Card title="Herramientas" desc="Frameworks, dashboards y guías prácticas." />
          </Link>

          <Link to="/admin/ai" style={cardStyle}>
            <Card title="IA" desc="Prompts, asistentes y flujos inteligentes." />
          </Link>

          <Link to="/admin/produccion/media" style={cardStyle}>
            <Card title="Media" desc="Biblioteca de audio, video y embeds reutilizables." />
          </Link>

        </section>
      </main>
    </>
  );
}

/* 🔹 Card reutilizable */
function Card({ title, desc }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div>
        <div style={{ fontWeight: 900, fontSize: 18 }}>{title}</div>
        <div style={{ marginTop: 6, color: "#6b7a88", fontSize: "0.92rem" }}>
          {desc}
        </div>
      </div>
      <div style={{ color: "#264763", fontWeight: 900 }}>→</div>
    </div>
  );
}

/* 🔹 Style */
const cardStyle = {
  border: "1px solid #e6ebf1",
  borderRadius: 14,
  padding: "14px 14px",
  background: "#fff",
  textDecoration: "none",
  boxShadow: "0 10px 30px rgba(0,0,0,.05)",
  display: "block",
  color: "inherit",
};